
declare global {

  // interface Array<T> {
  //   diff(arr: any): Array<T>;
  //   unique(): Array<T>;
  // }

  interface String {
    toProperCase(options?: {
      preserveAcronyms?: boolean;
      ignoreWords?: string[];
    }): string;
    toRemovePontuacao(): String;
    toPhone(): String;
  }

}



export default class CustomPrototype {

  public static register() {


    if (!String.prototype.toProperCase) {
      String.prototype.toProperCase = function (options?: {
        preserveAcronyms?: boolean;
        ignoreWords?: string[];
      }): string {
        const defaultIgnore = ['de', 'da', 'do', 'dos', 'das', 'e', 'a', 'o', 'as', 'os', 'em', 'com', 'por', 'para'];
        const ignoreWords = options?.ignoreWords ?? defaultIgnore;

        return this.split(/\s+/)
          .map(word => {
            const lower = word.toLowerCase();

            if (options?.preserveAcronyms && word === word.toUpperCase()) {
              return word;
            }

            if (ignoreWords.includes(lower)) {
              return lower;
            }

            return lower.charAt(0).toUpperCase() + lower.slice(1);
          })
          .join(' ');


        // Exemplos:
        //console.log(''.toProperCaseAdvanced("API de pagamento da zoop", { preserveAcronyms: true }));  // Saída: "API de Pagamento da Zoop"
        //console.log(''.toProperCaseAdvanced("orquestrador de pagamentos com nestjs e postgres"));      // Saída: "Orquestrador de Pagamentos com Nestjs e Postgres"
      };

    }

    if (!String.prototype.toRemovePontuacao) {
      String.prototype.toRemovePontuacao = function () {
        return this
          .replace(/\./g, '')
          .replace(/\//g, '')
          .replace(/\-/g, '')
          .replace(/\(/g, '')
          .replace(/\)/g, '')
          .replace(/\D/g, '');
      };
    }

    if (!String.prototype.toPhone) {
      String.prototype.toPhone = function () {

        if (!this) return '';

        // 1) Mantém apenas dígitos e '+'
        const apenasPermitidos = this.replace(/[^\d+]/g, '');

        // 2) Remove todos os '+' para poder recolocá-lo no início (se existir)
        const soDigitos = apenasPermitidos.replace(/\+/g, '');

        // 3) Se havia algum '+', garante exatamente um '+' no início; senão, apenas dígitos
        return /[+]/.test(apenasPermitidos) ? `+${soDigitos}` : soDigitos;



        // Exemplos:
        console.log('(11) 9 8765-4321'.toPhone());     // "11987654321"
        console.log('+55 (11) 9 8765-4321'.toPhone()); // "+5511987654321"
        console.log('55+11-98765+4321'.toPhone());     // "+5511987654321"
        console.log('++55 11 98765 4321'.toPhone());   // "+5511987654321"


      };
    }



  }

}




